import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg'
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg'
import { motion } from "motion/react"
import useLayout from "hooks/useLayout"
import useAuth from "@/hooks/useAuth"
import Cover from './Cover'
import OrdnatLogo from './OrdnatLogo'
import { APP_CONFIG } from "constants/constants"

interface MobileTopBarProps {
    storageId?: string;
    categoryId?: string;
    customerId?: string;
    productId?: string;
    transactionId?: string;
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({ 
    storageId, 
    categoryId, 
    customerId, 
    productId,
    transactionId
}) => {

    const { tokenIsValid } = useAuth()
    const {
        sidebarIsVisible,
        showSidebar,
        hideSidebar,
        showDialog
    } = useLayout()
    const showSearch = tokenIsValid === true && Boolean(storageId)

    // Handle menu toggle click.
    const handleMenuToggle = () => {
        if (sidebarIsVisible) {
            hideSidebar()
        } else {
            showSidebar()
        }
    }

    // Render top bar.
    return (
        <>
            <Cover visible={sidebarIsVisible} onClose={hideSidebar} enableClickClose={true} topClassName="top-14" zClassName="z-[100]" />
            <div id={`mobile-top-bar`} className={`
                h-14
                flex
                flex-row
                justify-between
                w-full
                fixed
                top-0
                left-0
                right-0
                z-[108]
                shadow-md
                items-center
                px-2
                bg-gray-100 bg-opacity-85 lg:bg-opacity-100 backdrop-blur-sm
            `}>

                {/* Left side: Menu Toggle */}
                <div className='flex gap-x-4 items-center'>
                    <motion.div
                        initial= {{
                            rotate: 0
                        }}
                        animate= {{
                            rotate: sidebarIsVisible ? 90 : 0,
                            transition: {
                                duration: APP_CONFIG.SHORT_ENTER_ANIMATION_DURATION
                            }
                        }}
                    >
                        <MenuIcon onClick={handleMenuToggle} className={`
                            w-8
                            h-8
                            cursor-pointer
                            fill-black
                        `} />
                    </motion.div>
                    <OrdnatLogo className="h-6" />
                </div>
                {/* Left side End */}

                {/* Right side: Search */}
                <div className={`
                    flex
                    gap-x-4
                    items-center
                `}>
                    {showSearch ?
                        <SearchIcon className={`
                            w-8
                            h-8
                            cursor-pointer
                            fill-black
                        `} onClick={() => showDialog(`search`)} /> :
                        null
                    }
                </div>
                {/* Right side End */}

            </div>
        </>
    )
}

export default MobileTopBar

